import Repository from './Repository'

const resourceStaff = 'sms/members'
const resourceAvatarAgent = '/sms/generate-avatar'
const resourceMessage = 'sms/member-messages'
const resourceReadMessage = 'sms/read-message'
const resourcePostMessage = 'sms/messages'
const resourceSmsUnreadMessage = 'sms/unread-message'

export default {
  getListStaff (data, reload = false) {
    return Repository.get(`${resourceStaff}`, data, {}, reload)
  },
  detailStaff (idStaff, reload = true) {
    return Repository.get(`${resourceStaff}/${idStaff}`, {}, {}, reload)
  },
  generateAvatarAgent (data, reload = true) {
    return Repository.post(`${resourceAvatarAgent}`, data, {}, reload)
  },
  memberListMessages (data) {
    try {
      let params = {}
      if (data.start_after) {
        params = {
          ...params,
          start_after: data.start_after
        }
      }
      return Repository.get(`${resourceMessage}/${data.idStaff}`, params, {}, data.reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  loadMoreListMessages (data) {
    try {
      if (data.start_after) {
        return Repository.get(`${resourceMessage}/${data.idStaff}?start_after=${data.start_after}`, {}, {}, data.reload)
      } else {
        return Repository.get(`${resourceMessage}/${data.idStaff}`, {}, {}, data.reload)
      }
    } catch (e) {
      return this.setErrors(e)
    }
  },
  reloadMessage (data) {
    try {
      return Repository.get(`${resourceMessage}/${data.idStaff}?end_before=${data.end_before}`, {}, {}, data.reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  reloadReadMessage (data) {
    try {
      return Repository.get(`${resourceMessage}/${data.idStaff}?from=${data.from}&order_by=${data.order_by}`, {}, {}, data.reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async readMessage (data, reload = false) {
    try {
      return Repository.put(`${resourceReadMessage}`, data, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async unreadMessage (data, reload = false) {
    try {
      return Repository.put(`${resourceSmsUnreadMessage}`, data, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async postMessage (data, reload = false) {
    try {
      return Repository.post(`${resourcePostMessage}`, data, { headers: { 'content-type': 'multipart/form-data' } }, {}, reload, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async postMessageText (data, reload = false) {
    try {
      return Repository.post(`${resourcePostMessage}`, data, {}, {}, !reload, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  deleteMessage (data, reload = false) {
    try {
      if (data.type === 'image') {
        return Repository.delete(`${resourcePostMessage}/${data.message_id}`, { storage_path: data.storage_path }, {}, reload)
      } else {
        return Repository.delete(`${resourcePostMessage}/${data.message_id}`, {}, {}, reload)
      }
    } catch (e) {
      return this.setErrors(e)
    }
  },
  editMessage (data, reload = false) {
    try {
      return Repository.put(`${resourcePostMessage}/${data.message_id} `, data, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getList (url) {
    try {
      return await Repository.get(url)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getListAreas (reload = false) {
    try {
      return Repository.get('sms/areas', {}, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getReceptionMessage (doc_id, isSilent = false) {
    try {
      return Repository.get(`sms/reception-message/${doc_id}`, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async sendReceptionMessage (doc_id, isSilent = false) {
    try {
      return Repository.post(`sms/reception-message/${doc_id}`, {}, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  }
}
